export default "__VITE_ASSET__C$XCt8$G__"